export default __webpack_public_path__ + "static/media/mpeg.4e63e6d0.png";